export type LoginLookupResponse = {
  authType?: string;
  authorize_href?: string;
  identityProvider?: string;
  requiresTempPassword?: boolean;
  status?: string;
  userStatus?: string;
};

export type LoginLookupResult =
  | { authType: "basic" }
  | { authType: "temporaryPassword" }
  | { authType: "sso"; identityProvider: string };

export function mapLoginLookupResponse(
  data: LoginLookupResponse,
): LoginLookupResult {
  if (
    data.authType === "sso" ||
    (data.authorize_href && data.identityProvider)
  ) {
    if (!data.identityProvider) {
      return { authType: "basic" };
    }

    return {
      authType: "sso",
      identityProvider: data.identityProvider,
    };
  }

  if (
    data.authType === "temporaryPassword" ||
    data.requiresTempPassword ||
    data.userStatus === "FORCE_CHANGE_PASSWORD" ||
    data.status === "FORCE_CHANGE_PASSWORD"
  ) {
    return { authType: "temporaryPassword" };
  }

  return { authType: "basic" };
}
